import React, { useState } from "react";
import { Box, TextField, Button, Typography } from "@mui/material";

function Login() {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [error, setError] = useState("");

    const handleSubmit = async () => {
        setError("");

        const res = await fetch("http://localhost:4000/auth/login", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ email, password }),
        });

        if (res.ok) {
            const data = await res.json();
            localStorage.setItem("authToken", data.token);

            // ✅ Redirection directe après login
            window.location.href = "/dashboard";
        } else {
            setError("Identifiants incorrects");
        }
    };

    return (
        <Box sx={{ width: 300, margin: "100px auto", textAlign: "center" }}>
            <Typography variant="h5">Connexion</Typography>

            <TextField
                fullWidth
                label="Email"
                margin="normal"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
            />

            <TextField
                fullWidth
                type="password"
                label="Mot de passe"
                margin="normal"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
            />

            {error && (
                <Typography color="error" sx={{ marginTop: 1 }}>
                    {error}
                </Typography>
            )}

            <Button
                fullWidth
                variant="contained"
                sx={{ marginTop: 2 }}
                onClick={handleSubmit}
            >
                Se connecter
            </Button>
        </Box>
    );
}

export default Login;
